import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DxButtonModule, DxHtmlEditorModule, DxBarGaugeModule, DxSchedulerModule, DxTreeViewModule, DxDraggableModule, DxPopoverModule, DxPopoverComponent, DxButtonGroupModule, DxGanttModule, DxSwitchModule, DxTreeListModule, DxFormModule, DxMenuModule, DxValidatorModule, DxPieChartModule, DxPieChartComponent, DxChartComponent, DxChartModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxTabPanelModule, DxListModule, DxLoadPanelModule, DxDateBoxModule, DxSelectBoxModule, DxBoxModule, DxPopupModule, DxDropDownBoxModule,
  DxCalendarModule, DxNumberBoxModule, DxDrawerModule, DxLoadIndicatorModule, DxTabsModule, DxToolbarModule, DxTextBoxModule, DxTooltipModule,
  DxTextAreaModule, DxScrollViewModule } from 'devextreme-angular';

import { GridAdditionComponent } from './components/grid-addition/grid-addition.component';
import { GridEditComponent } from './components/grid-edit/grid-edit.component';
import { GridEditInDetailComponent } from './components/grid-edit-in-detail/grid-edit-in-detail.component';
import { GridEditWeekComponent } from './components/grid-edit-week/grid-edit-week.component';
import { GridExpenseComponent } from './components/grid-expense/grid-expense.component';
import { GridTimelistComponent } from './components/grid-timelist/grid-timelist.component';
import { GridEmployeeComponent } from './components/grid-employee/grid-employee.component';
import { LeftMenuComponent } from "./components/left-menu/left-menu.component";
import { GridSectionComponent } from "./components/grid-section/grid-section.component";
import { ElevationSectionComponent } from "./components/elevation-section/elevation-section.component";
import { LeftToolbarComponent } from "./components/left-toolbar/left-toolbar.component";
import { SearchComponent } from "./components/search/search.component";
import { SearchSectionComponent } from "./components/search/search-section/search-section.component";
import { SearchSectionItemComponent } from "./components/search/search-section-item/search-section-item.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { TimesalaryapprovalDetailTimeComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/timesalaryapproval-detail-time.component'
import { EditTransportComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport.component';
import { EditTransportTimeComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-time/edit-transport-time.component';
import { EditTransportEquipmentComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-equipment/edit-transport-equipment.component';
import { EditTransportTransportarticleComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-transportarticle/edit-transport-transportarticle.component';
import { EditTransportAdditionComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-addition/edit-transport-addition.component';
import { EditTransportTimeAdditionComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-time-addition/edit-transport-time-addition.component';
import { EditTransportExpenseComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-expense/edit-transport-expense.component';
import { EditTransportLogtimesComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-logtimes/edit-transport-logtimes.component';
import { EditTransportWeekoverviewComponent } from 'src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/edit-transport/edit-transport-weekoverview/edit-transport-weekoverview.component';
import { ProjectPortalApprovalWeekComponent } from 'src/app/modules/project/project-portal/project-portal-admin/project-portal-approval-week/project-portal-approval-week.component';
import { DateSelectorComponent } from './components/date-selector/date-selector.component';
import { WeekSelectorComponent } from './components/week-selector/week-selector.component';
import { EmployeeListBalanceComponent } from 'src/app/modules/employee/employee-portal/employee-list-balance/employee-list-balance.component';
import { EmployeeListBalancePerEmployeeComponent } from 'src/app/modules/employee/employee-portal/employee-list-balance/employee-list-balance-per-employee/employee-list-balance-per-employee.component';

import { DynamicLayoutGridComponent } from './components/dynamic-layout/renderers/dynamic-layout-grid/dynamic-layout-grid.component';
import { DynamicLayoutHtmlTableComponent } from './components/dynamic-layout/renderers/dynamic-layout-html-table/dynamic-layout-html-table.component';

import { DynamicLayoutTileComponent } from './components/dynamic-layout/dynamic-layout-tile/dynamic-layout-tile.component';
import { DynamicLayoutComponent } from './components/dynamic-layout/dynamic-layout/dynamic-layout.component';
import { DynamicGroupedLayoutComponent } from './components/dynamic-layout/dynamic-grouped-layout/dynamic-grouped-layout.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DataGridComponent } from './_devextreme/data-grid/data-grid.component';
import { HtmlEditorComponent } from './_devextreme/html-editor/html-editor.component';
import { BarGaugeComponent } from './_devextreme/bar-gauge/bar-gauge.component';
import { PopupComponent } from './_devextreme/popup/popup.component';
import { TimePipe } from './pipes/time.pipe';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { PeriodSumComponent } from './components/period-sum/period-sum.component';
import { FilterPipe } from './pipes/filter.pipe';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SchedulerComponent } from './_devextreme/scheduler/scheduler.component';
import { TreeViewComponent } from './_devextreme/tree-view/tree-view.component';
import { DraggableComponent } from './_devextreme/draggable/draggable.component';
import { SearchPopupComponent } from './_devextreme/search-popup/search-popup.component';
import { QuickSearchPopupComponent } from './_devextreme/quick-search-popup/quick-search-popup.component';
import { LoadIndicatorComponent } from './components/load-indicator/load-indicator.component';
import { TabPanelButtonGroupComponent } from './_devextreme/tab-panel-button-group/tab-panel-button-group.component';
import { SchedulerPopupComponent } from './_devextreme/scheduler-popup/scheduler-popup.component';
import { GanttComponent } from './_devextreme/gantt/gantt.component';
import { TreeListComponent } from './_devextreme/tree-list/tree-list.component';

import { SignalRModule, SignalRConfiguration } from 'ng2-signalr';
import { locale } from 'devextreme/localization';
import { TransactionErrorComponent } from "./components/transaction-error/transaction-error.component";
import { NavComponent } from './components/nav/nav.component';
import { DynamicSubMenuItemComponent } from './components/dynamic-layout/dynamic-sub-menu-item/dynamic-sub-menu-item.component';
import { CardComponent } from './components/card/card.component';
import { SearchTreeViewComponent } from './components/search-tree-view/search-tree-view.component';
import { ForecastDetailOrdersComponent } from "../modules/planning/forecast/forecast-detail/forecast-detail-orders/forecast-detail-orders.component";

import { SettingsComponent } from './components/printer/settings/settings.component';
import { ResetTimeComponent } from './components/reset-time/reset-time.component';
import { ChangePasswordComponent } from "../modules/profile/change-password/change-password.component";
import { DxiSeriesComponent, DxoArgumentAxisComponent, DxoArgumentAxisModule, DxoCommonSeriesSettingsComponent, DxoConnectorComponent, DxoFontComponent, DxoFontModule, DxoLegendComponent, DxoSeriesTemplateComponent, DxoSizeComponent, DxoSubtitleComponent, DxoSubtitleModule, DxoTileComponent, DxoTitleComponent, DxoTitleModule } from "devextreme-angular/ui/nested";
import { PortalTemplateTimetypeSelectorComponent } from './components/portal-template-timetype-selector/portal-template-timetype-selector.component';
import { EmployeeAmlWeekComponent } from '../modules/employee/employee-portal/employee-aml-week/employee-aml-week.component';
import { TimeFormatPipe } from "./pipes/time-format.pipe";
import { MaskedTimeInputComponent } from './_devextreme/masked-time-input/masked-time-input.component';
import { ProjectPortalListDetailAdditionComponent } from '../modules/project/project-portal/project-portal-list-detail/project-portal-list-detail-addition/project-portal-list-detail-addition.component';
import { ProjectPortalListDetailEmployeeComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-employee/project-portal-list-detail-employee.component';
import { ProjectPortalListDetailExpenseComponent } from '../modules/project/project-portal/project-portal-list-detail/project-portal-list-detail-expense/project-portal-list-detail-expense.component';
import { ProjectPortalListDetailLogComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-log/project-portal-list-detail-log.component';
import { ProjectPortalLogDetailGridComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-log/project-portal-log-detail-grid/project-portal-log-detail-grid.component';
import { ProjectPortalApprovalDetailsComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-approval-details/project-portal-approval-details.component';
import { ProjectPortalApprovalEmployeeEquipmentsComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-employee/equipments/equipments.component';
import { ProjectPortalApprovalEmployeeArticlesComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-employee/articles/articles.component';
import { ProjectPortalApprovalEmployeeAdditionsComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-employee/additions/additions.component';
import { ProjectPortalApprovalEmployeeExpensesComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-list-detail-employee/expenses/expenses.component';
import { ProjectPortalApprovalDetailsCarrierItemFlowsComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-approval-details/carrier-item-flows/carrier-item-flows.component';
import { ProjectPortalApprovalAttachmentComponent } from '../modules/project/project-portal/project-portal-approval/project-portal-approval-attachment/project-portal-approval-attachment.component';
import { PagerComponent } from './components/pager/pager.component';
import { TimePeriodSelectorComponent } from './components/time-period-selector/time-period-selector.component';
import { ProjectPortalEmployeeSelectorComponent } from "./components/project-portal-employee-selector/project-portal-employee-selector.component";
import { LoadPanelComponent } from './_devextreme/load-panel/load-panel.component';
import { ExpandableElevationSectionComponent } from './components/expandable-elevation-section/expandable-elevation-section.component';
import { TimeLogComponent } from '../modules/project/project-portal/project-portal-approval/time-log/time-log.component';
import { QuickEntryComponent } from "../modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/quick-entry/quick-entry.component";

locale(navigator.language);

// SignalR configuration
export function signalRConfiguration(): SignalRConfiguration {
  const c = new SignalRConfiguration();
  c.logging = true;

  // >= v5.0.0
  c.executeEventsInZone = true; // optional, default is true
  c.executeErrorsInZone = false; // optional, default is false
  c.executeStatusChangeInZone = true; // optional, default is true

  return c;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DxButtonModule,
    DxDataGridModule,
    DxTabPanelModule,
    DxListModule,
    DxLoadPanelModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxBoxModule,
    DxPopupModule,
    DxDropDownBoxModule,
    DxCalendarModule,
    DxNumberBoxModule,
    DxDrawerModule,
    DxLoadIndicatorModule,
    DxTabsModule,
    DxToolbarModule,
    DxTextBoxModule,
    DxTooltipModule,
    DxTextAreaModule,
    DxScrollViewModule,
    FontAwesomeModule,
    DxHtmlEditorModule,
    DxBarGaugeModule,
    DxSchedulerModule,
    DxTreeViewModule,
    DxDraggableModule,
    DxPopoverModule,
    DxButtonGroupModule,
    DxGanttModule,
    DxSwitchModule,
    DxTreeListModule,
    DxFormModule,
    DxMenuModule,
    DxValidatorModule,
    DxPieChartModule,
    DxChartModule,
    DxoTitleModule,
    DxoSubtitleModule,
    DxoFontModule,
    DxoArgumentAxisModule,
    DxLoadPanelModule,
    SignalRModule.forRoot(signalRConfiguration)
  ],
  declarations: [
    GridAdditionComponent,
    GridEditComponent,
    GridEditInDetailComponent,
    GridEditWeekComponent,
    GridExpenseComponent,
    GridTimelistComponent,
    GridEmployeeComponent,
    DateSelectorComponent,
    WeekSelectorComponent,
    LeftMenuComponent,
    GridSectionComponent,
    ElevationSectionComponent,
    LeftToolbarComponent,
    SearchComponent,
    SearchSectionComponent,
    SearchSectionItemComponent,
    SpinnerComponent,
    TimesalaryapprovalDetailTimeComponent,
    EditTransportComponent,
    EditTransportTimeComponent,
    EditTransportEquipmentComponent,
    EditTransportTransportarticleComponent,
    EditTransportAdditionComponent,
    EditTransportTimeAdditionComponent,
    EditTransportExpenseComponent,
    EditTransportLogtimesComponent,
    EditTransportWeekoverviewComponent,
    QuickEntryComponent,
    ProjectPortalApprovalWeekComponent,
    EmployeeListBalanceComponent,
    EmployeeListBalancePerEmployeeComponent,
    EmployeeAmlWeekComponent,
    DynamicLayoutGridComponent,
    DynamicLayoutTileComponent,
    DynamicLayoutComponent,
    DynamicGroupedLayoutComponent,
    DynamicLayoutHtmlTableComponent,
    DataGridComponent,
    HtmlEditorComponent,
    BarGaugeComponent,
    PopupComponent,
    TimePipe,
    TimeFormatPipe,
    FilePreviewComponent,
    PeriodSumComponent,
    FilterPipe,
    SideMenuComponent,
    SchedulerComponent,
    TreeViewComponent,
    DraggableComponent,
    SearchPopupComponent,
    QuickSearchPopupComponent,
    LoadIndicatorComponent,
    TabPanelButtonGroupComponent,
    SchedulerPopupComponent,
    GanttComponent,
    TreeListComponent,
    NavComponent,
    TransactionErrorComponent,
    DynamicSubMenuItemComponent,
    CardComponent,
    SettingsComponent,
    SearchTreeViewComponent,
    ResetTimeComponent,
    ForecastDetailOrdersComponent,
    ChangePasswordComponent,
    PortalTemplateTimetypeSelectorComponent,
    MaskedTimeInputComponent,
    ProjectPortalListDetailAdditionComponent,
    ProjectPortalListDetailEmployeeComponent,
    ProjectPortalListDetailExpenseComponent,
    ProjectPortalListDetailLogComponent,
    ProjectPortalLogDetailGridComponent,
    ProjectPortalApprovalDetailsComponent,
    ProjectPortalApprovalEmployeeEquipmentsComponent,
    ProjectPortalApprovalEmployeeArticlesComponent,
    ProjectPortalApprovalEmployeeAdditionsComponent,
    ProjectPortalApprovalEmployeeExpensesComponent,
    ProjectPortalApprovalDetailsCarrierItemFlowsComponent,
    ProjectPortalApprovalAttachmentComponent,
    PagerComponent,
    TimePeriodSelectorComponent,
    ProjectPortalEmployeeSelectorComponent,
    LoadPanelComponent,
    ExpandableElevationSectionComponent,
    TimeLogComponent
  ],
    exports: [
        GridAdditionComponent,
        GridEditComponent,
        GridEditInDetailComponent,
        GridEditWeekComponent,
        GridExpenseComponent,
        GridTimelistComponent,
        GridEmployeeComponent,
        DateSelectorComponent,
        WeekSelectorComponent,
        LeftMenuComponent,
        GridSectionComponent,
        ElevationSectionComponent,
        LeftToolbarComponent,
        SearchComponent,
        SearchSectionComponent,
        SearchSectionItemComponent,
        SpinnerComponent,
        TimesalaryapprovalDetailTimeComponent,
        EditTransportComponent,
        EditTransportTimeComponent,
        EditTransportEquipmentComponent,
        EditTransportTransportarticleComponent,
        EditTransportAdditionComponent,
        EditTransportTimeAdditionComponent,
        EditTransportExpenseComponent,
        EditTransportLogtimesComponent,
        EditTransportWeekoverviewComponent,
        QuickEntryComponent,
        ProjectPortalApprovalWeekComponent,
        EmployeeListBalanceComponent,
        EmployeeListBalancePerEmployeeComponent,
        EmployeeAmlWeekComponent,
        CommonModule,
        FormsModule,
        DynamicLayoutGridComponent,
        DynamicLayoutTileComponent,
        DynamicLayoutComponent,
        DynamicGroupedLayoutComponent,
        DynamicLayoutHtmlTableComponent,
        DynamicSubMenuItemComponent,
        HtmlEditorComponent,
        DataGridComponent,
        BarGaugeComponent,
        PopupComponent,
        TimePipe,
        TimeFormatPipe,
        FilePreviewComponent,
        PeriodSumComponent,
        FilterPipe,
        SideMenuComponent,
        SchedulerComponent,
        TreeViewComponent,
        DraggableComponent,
        DxPopoverComponent,
        SearchPopupComponent,
        QuickSearchPopupComponent,
        LoadIndicatorComponent,
        TabPanelButtonGroupComponent,
        GanttComponent,
        TreeListComponent,
        TransactionErrorComponent,
        NavComponent,
        CardComponent,
        SettingsComponent,
        SearchTreeViewComponent,
        ResetTimeComponent,
        ForecastDetailOrdersComponent,
        ChangePasswordComponent,
        DxPieChartComponent,
        DxChartComponent,
        DxoTitleComponent,
        DxoSubtitleComponent,
        DxoFontComponent,
        DxoArgumentAxisComponent,
        DxoLegendComponent,
        DxoCommonSeriesSettingsComponent,
        DxoSizeComponent,
        DxoSeriesTemplateComponent,
        DxiSeriesComponent,
        DxoConnectorComponent,
        PortalTemplateTimetypeSelectorComponent,
        MaskedTimeInputComponent,
        ProjectPortalListDetailAdditionComponent,
        ProjectPortalListDetailEmployeeComponent,
        ProjectPortalListDetailExpenseComponent,
        ProjectPortalListDetailLogComponent,
        ProjectPortalLogDetailGridComponent,
        ProjectPortalApprovalDetailsComponent,
        ProjectPortalApprovalEmployeeEquipmentsComponent,
        ProjectPortalApprovalEmployeeArticlesComponent,
        ProjectPortalApprovalEmployeeAdditionsComponent,
        ProjectPortalApprovalEmployeeExpensesComponent,
        ProjectPortalApprovalDetailsCarrierItemFlowsComponent,
        ProjectPortalApprovalAttachmentComponent,
        PagerComponent,
        TimePeriodSelectorComponent,
        ProjectPortalEmployeeSelectorComponent,
        LoadPanelComponent,
        ExpandableElevationSectionComponent
    ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
